export default [{
		//首页
		path: '/home',
		name: 'home',
		meta: {
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/home.vue'], resolve)
	}, {
		//企业证书
		path: '/companyCertificate',
		name: 'companyCertificate',
		meta: {
			//键名
			key: '',
			detail: {
				//需要跳转到的详情页面name地址
				name: 'companyCertificateDetail',
			},
			edit: {
				name: 'companyCertificateEdit'
			},
			add :{
				name: 'companyCertificateAdd'
			},
			keepAlive:true,
			//删除操作对象
			delPromise: '',
		},
		component: (resolve) => require(['@/pages/certificateManger/company/index.vue'], resolve)
	}, {
		//数字证书
		path: '/digitalCertificate',
		name: 'digitalCertificate',
		meta: {
			detail: {
				name: 'digitalCertificateDetail',
			},
			edit: {
				name: 'digitalCertificateEdit'
			},
			add: {
				name: 'digitalCertificateAdd'
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/certificateManger/digital/index.vue'], resolve)
	}, {
		//人员证书
		path: '/personCertificate',
		name: 'personCertificate',
		meta: {
			detail: {
				name: 'personCertificateDetail',
			},
			edit: {
				name: 'personCertificateEdit',
			},
			add: {
				name: 'personCertificateAdd',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/certificateManger/person/index.vue'], resolve)
	}, {
		//文件柜
		path: '/CertificateFileCabinet',
		name: 'CertificateFileCabinet',
		meta: {
			key: 'file_folder_id',
			detail: {
				name: 'seeCabinet',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/certificateManger/cabinet/index.vue'], resolve)
	}, {
		//管理文件柜
		path: '/MandCabinet',
		name: 'MandCabinet',
		meta: {
			key: 'file_cabinet_id',
			detail: {
				name: 'CertificateFileCabinet',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/certificateManger/cabinet/mand.vue'], resolve)
	}, {
		//文件柜详细列表
		path: '/seeCabinet',
		name: 'seeCabinet',
		meta: {
			detail: {
				name: 'personCertificateDetail',
			},
			add: {
				name: 'moveCabinet',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/certificateManger/cabinet/see.vue'], resolve)
	}, {
		//文件柜下文件夹移动操作
		path: '/moveCabinet',
		name: 'moveCabinet',
		component: (resolve) => require(['@/pages/certificateManger/cabinet/move.vue'], resolve)
	},
	// {
	// 	//考试管理
	// 	path: '/ExaminationManage',
	// 	name: 'ExaminationManage',
	// 	meta: {
	// 		key: 'project_contract_id',
	// 		detail: {
	// 			name: 'ExaminationDetail',
	// 		},
	// 		edit: {
	// 			name: 'ExaminationEdit',
	// 		}
	// 	},
	// 	component: (resolve) => require(['@/pages/certificateManger/test/index.vue'], resolve)
	// },
	// {
	// 	//考试管理新增编辑
	// 	path: '/ExaminationEdit',
	// 	name: 'ExaminationEdit',
	// 	component: (resolve) => require(['@/pages/certificateManger/test/edit.vue'], resolve)
	// }, 
	// {
	// 	//考试管理查看详情
	// 	path: '/ExaminationDetail',
	// 	name: 'ExaminationDetail',
	// 	component: (resolve) => require(['@/pages/certificateManger/test/detail.vue'], resolve)
	// },
	{
		//在职员工
		path: '/IncumbentEmployee',
		name: 'IncumbentEmployee',
		meta: {
			key: 'emp_id',
			detail: {
				name: 'IncumbentEmployeeDetail',
			},
			edit: {
				name: 'IncumbentEmployeeEdit',
			},
			add: {
				name: 'IncumbentEmployeeAdd',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/StaffPage/IncumbentEmployee.vue'], resolve)
	}, {
		//离职员工
		path: '/ResignationEmployee',
		name: 'ResignationEmployee',
		meta: {
			key: 'emp_id',
			detail: {
				name: 'ResignationEmployeeDetail',
			},
			edit: {
				name: 'ResignationEmployeeEdit',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/StaffPage/ResignationEmployee.vue'], resolve)
	}, {
		//企业通讯录
		path: '/ComAddressBook',
		name: 'ComAddressBook',
		meta: {},
		component: (resolve) => require(['@/pages/StaffPage/ComAddressBook.vue'], resolve)
	}, {
		//投标项目
		path: '/TenderProject',
		name: 'TenderProject',
		meta: {
			key: 'project_tender_id',
			detail: {
				name: 'TenderProjectDetail',
			},
			edit: {
				name: 'tenderProjectEdit'
			},
			add: {
				name: 'TenderProjectAdd'
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/bidManagement/TenderProject.vue'], resolve)
	}, {
		//中标项目
		path: '/WinningBidProject',
		name: 'WinningBidProject',
		meta: {
			key: 'project_tender_id',
			detail: {
				name: 'WinningBidProjectDetail',
			},
			edit: {
				name: 'winningBidProjectEdit'
			},
			add: {
				name: 'WinningBidProjectAdd'
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/bidManagement/WinningBidProject.vue'], resolve)
	},
	{
		//在建项目
		path: '/UnderProject',
		name: 'UnderProject',
		meta: {
			key: 'projectId',
			detail: {
				name: 'UnderProjectDetail',
			},
			edit: {
				name: 'underProjectEdit'
			},
			add: {
				name: 'UnderProjectAdd'
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/projectManagement/UnderProject.vue'], resolve)
	}, {
		//竣工项目
		path: '/CompletionProject',
		name: 'CompletionProject',
		meta: {
			key: 'projectId',
			detail: {
				name: 'CompletionProjectDetail',
			},
			edit: {
				name: 'completionProjectEdit'
			},
			add: {
				name: 'CompletionProjectAdd'
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/projectManagement/CompletionProject.vue'], resolve)
	},
	{
		//收款合同
		path: '/ReceiptContract',
		name: 'ReceiptContract',
		meta: {
			key: 'project_contract_id',
			detail: {
				name: 'ReceiptContractDetail',
			},
			edit: {
				name: 'receiptContractEdit',
			},
			add: {
				name: 'ReceiptContractAdd',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/contractManagement/ReceiptContract.vue'], resolve)
	}, {
		//付款合同
		path: '/PaymentContract',
		name: 'PaymentContract',
		meta: {
			key: 'project_contract_id',
			detail: {
				name: 'PaymentContractDetail',
			},
			edit: {
				name: 'paymentContractEdit',
			},
			add: {
				name: 'PaymentContractAdd',
			},
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/projectPage/contractManagement/PaymentContract.vue'], resolve)
	}
]


// WEBPACK FOOTER //
// ./src/router/map/wzm.js